var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGmcaLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 129 39.9",
    style: {
      enableBackground: "new 0 0 129 39.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.3,6.7c-0.1-1.9-1.5-3.6-4.1-3.6c-3,0-4.4,2-4.4,5.1v2.9c0,3.1,1.3,5.3,4.5,5.3c2.7,0,4.2-1.7,4.2-3.7v-0.3 H8.2v-3H16v2.4c0,4.5-3.1,7.6-7.9,7.6C2.6,19.3,0,15.6,0,11V8.3C0,3.3,3,0,8,0c4.8,0,7.7,2.8,7.8,6.7H12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.8,19h-3.5V7.5l-3.5,6.9h-3.3L23,7.5V19h-3.5V0.4h3.4L28.1,11l5.2-10.6h3.4V19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.3,11V8.3c0-4.8,2.5-8.3,8.1-8.3c4.7,0,7.6,3.2,7.8,7h-3.4c-0.2-2.1-1.6-3.9-4.3-3.9 c-3.1,0-4.4,2.1-4.4,5.1v3c0,3,1.3,5.1,4.4,5.1c2.8,0,4.1-1.8,4.3-3.9h3.4c-0.2,3.8-3.1,7-7.8,7C42.8,19.3,40.3,15.7,40.3,11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.5,12.1h5.3l-2.6-8.4L63.5,12.1z M74.6,19H71L69.7,15h-7.2L61.3,19h-3.7l6.6-18.6H68L74.6,19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M129,8.5H78.9V8.2H129V8.5z M129,19H78.9v-0.3H129V19z M129,29.5H78.9v-0.3H129V29.5z M129,40H78.9v-0.3H129 V40z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.8,2.4c0-0.5-0.4-1-1.2-1c-0.8,0-1.2,0.6-1.2,1.4v0.8c0,0.9,0.4,1.5,1.3,1.5c0.8,0,1.2-0.5,1.2-1V4h-1.2 V3.1h2.2v0.7c0,1.2-0.9,2.1-2.2,2.1c-1.5,0-2.3-1-2.3-2.3V2.8c0-1.4,0.8-2.3,2.2-2.3c1.3,0,2.1,0.8,2.2,1.9H82.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87,3.3c0.6,0,1-0.4,1-0.9c0-0.6-0.3-0.9-1-0.9h-1.2v1.8H87z M86.9,4.1h-1.1v1.7h-1V0.6h2.3 c1.2,0,1.9,0.8,1.9,1.8c0,0.7-0.4,1.3-1,1.6L89,5.8h-1.2L86.9,4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.9,0.6h3.6v0.9H91v1.3h2.4v0.9H91v1.3h2.6v0.9h-3.6V0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.8,3.9h1.5l-0.7-2.3L95.8,3.9z M98.9,5.8h-1l-0.3-1.1h-2l-0.3,1.1h-1L96,0.6H97L98.9,5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.3,1.5h-1.5V0.6h4v0.9h-1.5v4.3h-1V1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.5,0.6h3.6v0.9h-2.6v1.3h2.4v0.9h-2.4v1.3h2.6v0.9h-3.6V0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M110.3,3.3c0.6,0,1-0.4,1-0.9c0-0.6-0.3-0.9-1-0.9h-1.2v1.8H110.3z M110.2,4.1h-1.1v1.7h-1V0.6h2.3 c1.2,0,1.9,0.8,1.9,1.8c0,0.7-0.4,1.3-1,1.6l1.1,1.8h-1.2L110.2,4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.3,16.3h-1v-3.2l-1,1.9h-0.9l-1-1.9v3.2h-1v-5.2h1l1.5,3l1.5-3h1V16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.7,14.4h1.5l-0.7-2.3L86.7,14.4z M89.8,16.3h-1l-0.3-1.1h-2l-0.3,1.1h-1l1.9-5.2H88L89.8,16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.6,11.1h1l2.3,3.5v-3.5h1v5.2h-1l-2.3-3.5v3.5h-1V11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.8,14.1v-0.7c0-1.3,0.7-2.3,2.3-2.3c1.3,0,2.1,0.9,2.2,2h-1c-0.1-0.6-0.4-1.1-1.2-1.1 c-0.9,0-1.2,0.6-1.2,1.4v0.8c0,0.8,0.4,1.4,1.2,1.4c0.8,0,1.1-0.5,1.2-1.1h1c-0.1,1.1-0.9,2-2.2,2C96.5,16.4,95.8,15.4,95.8,14.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M101.2,11.1h1v2.1h2.1v-2.1h1v5.2h-1v-2.1h-2.1v2.1h-1V11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.5,11.1h3.6V12h-2.6v1.3h2.4v0.9h-2.4v1.3h2.6v0.9h-3.6V11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M110.9,14.8v-0.1h1v0.1c0,0.5,0.4,0.8,1.1,0.8c0.6,0,1-0.3,1-0.8c0-0.3-0.1-0.5-0.5-0.6l-1.4-0.3 c-0.8-0.2-1.2-0.6-1.2-1.3c0-1,0.7-1.6,1.9-1.6c1.1,0,1.9,0.6,1.9,1.6v0.1h-1v-0.1c0-0.4-0.3-0.8-0.9-0.8c-0.5,0-0.9,0.2-0.9,0.7 c0,0.3,0.2,0.5,0.4,0.5l1.4,0.4c0.8,0.2,1.1,0.7,1.1,1.4c0,1-0.9,1.6-2.1,1.6C111.8,16.4,110.9,15.8,110.9,14.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116.8,12h-1.5v-0.9h4V12h-1.5v4.3h-1V12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.1,11.1h3.6V12h-2.6v1.3h2.4v0.9h-2.4v1.3h2.6v0.9h-3.6V11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M126.9,13.8c0.6,0,1-0.4,1-0.9c0-0.6-0.3-0.9-1-0.9h-1.2v1.8H126.9z M126.8,14.7h-1.1v1.7h-1v-5.2h2.3 c1.2,0,1.9,0.8,1.9,1.8c0,0.7-0.4,1.3-1,1.6l1.1,1.8h-1.2L126.8,14.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.3,24.6v-0.7c0-1.3,0.7-2.3,2.3-2.3c1.3,0,2.1,0.9,2.2,2h-1c-0.1-0.6-0.4-1.1-1.2-1.1 c-0.9,0-1.2,0.6-1.2,1.4v0.8c0,0.8,0.4,1.4,1.2,1.4c0.8,0,1.1-0.5,1.2-1.1h1c-0.1,1.1-0.9,2-2.2,2C80,26.9,79.3,25.9,79.3,24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88.1,24.7v-0.9c0-0.8-0.4-1.4-1.3-1.4c-0.9,0-1.3,0.6-1.3,1.4v0.9c0,0.8,0.4,1.4,1.3,1.4 C87.7,26.1,88.1,25.5,88.1,24.7z M89.2,24.6c0,1.3-0.8,2.3-2.3,2.3c-1.5,0-2.3-1-2.3-2.3v-0.8c0-1.3,0.8-2.3,2.3-2.3 c1.5,0,2.3,1,2.3,2.3V24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95,26.8h-1v-3.2l-1,1.9h-0.9l-1-1.9v3.2h-1v-5.2h1l1.5,3l1.5-3h1V26.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98.4,26c0.5,0,0.8-0.3,0.8-0.7c0-0.4-0.3-0.7-0.8-0.7h-1.3V26H98.4z M98.2,23.8c0.4,0,0.7-0.3,0.7-0.7 c0-0.4-0.3-0.6-0.7-0.6h-1.1v1.3H98.2z M96.1,21.6h2.3c0.9,0,1.5,0.5,1.5,1.3c0,0.6-0.3,1-0.7,1.2c0.5,0.1,1,0.5,1,1.2 c0,0.9-0.7,1.5-1.8,1.5h-2.4V21.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M101.1,21.6h1v5.2h-1V21.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.3,21.6h1l2.3,3.5v-3.5h1v5.2h-1l-2.3-3.5v3.5h-1V21.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108.7,21.6h3.6v0.9h-2.6v1.3h2.4v0.9h-2.4V26h2.6v0.9h-3.6V21.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116.5,23.7c0-0.8-0.4-1.2-1.3-1.2h-0.9V26h0.9c0.8,0,1.3-0.4,1.3-1.2V23.7z M115.4,21.6c1.4,0,2.1,0.9,2.1,2 v1.1c0,1.2-0.7,2-2.1,2h-2.1v-5.2H115.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.7,35.4h1.5l-0.7-2.3L80.7,35.4z M83.9,37.3h-1l-0.3-1.1h-2l-0.3,1.1h-1l1.9-5.2H82L83.9,37.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.4,35.5v-3.3h1v3.4c0,0.7,0.4,1.1,1.1,1.1s1.1-0.4,1.1-1.1v-3.4h1v3.3c0,1.2-0.8,2-2.1,2 S84.4,36.6,84.4,35.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.8,33h-1.5v-0.9h4V33h-1.5v4.3h-1V33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.1,32.1h1v2.1h2.1v-2.1h1v5.2h-1v-2.1h-2.1v2.1h-1V32.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102.8,35.2v-0.9c0-0.8-0.4-1.4-1.3-1.4c-0.9,0-1.3,0.6-1.3,1.4v0.9c0,0.8,0.4,1.4,1.3,1.4 C102.4,36.6,102.8,36,102.8,35.2z M103.9,35.1c0,1.3-0.8,2.3-2.3,2.3c-1.5,0-2.3-1-2.3-2.3v-0.8c0-1.3,0.8-2.3,2.3-2.3 c1.5,0,2.3,1,2.3,2.3V35.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.1,34.8c0.6,0,1-0.4,1-0.9c0-0.6-0.3-0.9-1-0.9h-1.2v1.8H107.1z M107,35.7h-1.1v1.7h-1v-5.2h2.3 c1.2,0,1.9,0.8,1.9,1.8c0,0.7-0.4,1.3-1,1.6l1.1,1.8h-1.2L107,35.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M110.1,32.1h1v5.2h-1V32.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M113.4,33h-1.5v-0.9h4V33h-1.5v4.3h-1V33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M119,37.3h-1v-1.9l-1.8-3.3h1.1l1.2,2.3l1.2-2.3h1.1l-1.8,3.3V37.3z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmcaLogo);
export default __webpack_public_path__ + "static/media/gmca-logo.090b193d7e92252c0ec281b860461a8b.svg";
export { ForwardRef as ReactComponent };